import s from './hr.module.css';

/** Tông chip loại giữ ghế (Primary → mute · Concurrent → warn · Acting → pri). */
export const SEAT_TONE_CLASS: Record<'mute' | 'warn' | 'pri', string> = { mute: s.tMute ?? '', warn: s.tWarn ?? '', pri: s.tPri ?? '' };
